import { isEnum } from "./types";

export enum SaslMechanism {
    Plain = "PLAIN",
    External = "EXTERNAL",
}

export const isSaslMechanism = isEnum(SaslMechanism);
